import { c as _c } from "react/compiler-runtime";
import { EllipseMiniSolid } from "@medusajs/icons";
import { Label, RadioGroup, Text, clx } from "@medusajs/ui";
type FilterRadioGroupProps = {
  title: string;
  items: {
    value: string;
    label: string;
  }[];
  value: any;
  handleChange: (...args: any[]) => void;
  "data-testid"?: string;
};
const FilterRadioGroup = t0 => {
  const $ = _c(12);
  const {
    title,
    items,
    value,
    handleChange,
    "data-testid": dataTestId
  } = t0;
  let t1;
  if ($[0] !== title) {
    t1 = <Text className="txt-compact-small-plus text-ui-fg-muted">{title}</Text>;
    $[0] = title;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] !== items || $[3] !== value) {
    t2 = items?.map(i => <div key={i.value} className={clx("flex gap-x-2 items-center", {
      "ml-[-23px]": i.value === value
    })}>{i.value === value && <EllipseMiniSolid />}<RadioGroup.Item checked={i.value === value} className="hidden peer" id={i.value} value={i.value} /><Label htmlFor={i.value} className={clx("!txt-compact-small !transform-none text-ui-fg-subtle hover:cursor-pointer", {
        "text-ui-fg-base": i.value === value
      })} data-testid="radio-label" data-active={i.value === value}>{i.label}</Label></div>);
    $[2] = items;
    $[3] = value;
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  let t3;
  if ($[5] !== dataTestId || $[6] !== handleChange || $[7] !== t2) {
    t3 = <RadioGroup data-testid={dataTestId} onValueChange={handleChange}>{t2}</RadioGroup>;
    $[5] = dataTestId;
    $[6] = handleChange;
    $[7] = t2;
    $[8] = t3;
  } else {
    t3 = $[8];
  }
  let t4;
  if ($[9] !== t1 || $[10] !== t3) {
    t4 = <div className="flex gap-x-3 flex-col gap-y-3">{t1}{t3}</div>;
    $[9] = t1;
    $[10] = t3;
    $[11] = t4;
  } else {
    t4 = $[11];
  }
  return t4;
};
export default FilterRadioGroup;